import React, { useCallback, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/ipe/workbench/ipe-workbench.css';
import IpeDeleteConfirmModal from '@/pages/ipe/workbench/modals/IpeDeleteConfirmModal';

/**
 * 命令式打开删除确认弹窗，替代 window.confirm
 * @returns {Promise<boolean>}
 */
export function showIpeDeleteConfirm({
  title = '确认删除',
  message,
  confirmLabel = '确认删除',
  cancelLabel = '取消',
}) {
  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);
    let settled = false;

    const cleanup = () => {
      try {
        root.unmount();
      } catch {
        /* ignore double unmount */
      }
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };

    const finish = (value) => {
      if (settled) return;
      settled = true;
      // 推迟 unmount，避免在当前 React 事件/setState 栈内同步卸载卡住页面
      queueMicrotask(() => {
        cleanup();
        resolve(value);
      });
    };

    function DeleteConfirmHost() {
      const [open, setOpen] = useState(true);
      const finishRef = useRef(finish);
      finishRef.current = finish;

      const handleClose = useCallback((value) => {
        setOpen(false);
        finishRef.current(value);
      }, []);

      return (
        <IpeDeleteConfirmModal
          open={open}
          title={title}
          confirmLabel={confirmLabel}
          cancelLabel={cancelLabel}
          onCancel={() => handleClose(false)}
          onConfirm={() => handleClose(true)}
          top
        >
          {message}
        </IpeDeleteConfirmModal>
      );
    }

    root.render(<DeleteConfirmHost />);
  });
}
